module.exports = __webpack_public_path__ + "947debff495b1a7681e189427a8f8185.MP3";